<template>
  <div class="about" v-loading="loading">
    <div class="aboutBox">
      <div class="aboutT flex jus navBox">
        <div class="aboutTImg">
          <img :src="aboutT.img" alt>
        </div>
        <div class="aboutTCon">
          <div class="aboutTCon_tit">
            <span class="chinaTit">{{aboutT.attrValue?aboutT.attrValue.name:""}}</span>
            <span class="engTit">{{aboutT.attrValue?aboutT.attrValue.abbreviation:""}}</span>
          </div>
          <div class="aboutTCon_brief">
            <p v-html="aboutT.attrValue?aboutT.attrValue.content:''"></p>
          </div>
        </div>
      </div>
      <div class="aboutNav navBox">
        <div class="history">
          <div class="aboutTCon_tit centerT">
            <span class="chinaTit">{{history.attrValue?history.attrValue.name:""}}</span>
            <span class="engTit">{{history.attrValue?history.attrValue.abbreviation:""}}</span>
          </div>
          <div class="aboutTCon_brief">
            <p v-html="history.attrValue?history.attrValue.content:''"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="how">
      <div class="aboutTCon_tit centerT">
        <span class="chinaTit">{{how.attrValue?how.attrValue.name:''}}</span>
        <span class="engTit">{{how.attrValue?how.attrValue.abbreviation:''}}</span>
      </div>
      <div class="aboutTCon_brief">
        <p v-html="how.attrValue?how.attrValue.content:''"></p>
      </div>
    </div>
    <div class="wgpsn">
      <div class="aboutTCon_tit centerT">
        <span class="chinaTit">{{workingTeam.chinaTit}}</span>
        <span class="engTit">{{workingTeam.engTit}}</span>
      </div>

      <div class="swiper-container wgpsnB">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in wgpsn" :key="index">
            <p class="wgT">{{item.attrValue.name}}</p>
            <div class="wgpsn_item flex" v-html="item.attrValue.content">
              <!-- <div class="wgpsn_item_T">
                <span class="wg_tit">职位</span>
                <div class="wg_con">主席：</div>
                <div class="wg_con">成员：</div>
              </div>-->
              <!-- <div class="wgpsn_item_B"> -->
              <!-- <div
                  class="wg_name wg_con_item flex jus"
                  v-for="(pItem, pIndx) in item.child"
                  :key="pIndx"
                >
                  <span
                    :class="pIndx == 0 ? 'wg_tit wg_con_item_c' : 'wg_con wg_con_item_c'"
                  >{{pItem.name}}</span>
                  <span
                    :class="pIndx == 0 ? 'wg_tit wg_con_item_c' : 'wg_con wg_con_item_c'"
                  >{{pItem.country}}</span>
              </div>-->
              <!-- </div> -->
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="faq">
      <div class="aboutTCon_tit centerT">
        <span class="chinaTit">{{faq.chinaTit}}</span>
        <span class="engTit">{{faq.engTit}}</span>
      </div>
      <div class="aboutTCon_brief">
        <div class="faq_list">
          <div class="faq_list_item flex flex_d jus" v-for="(item, index) in faq_list" :key="index">
            <div class="ask">问：{{item.attrValue.name}}</div>
            <div class="answer flex jus alignItem">
              <div class="answer_con">答：<span v-html="item.attrValue.answer"></span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="more" @click="qaMore">查看更多+</div>
    </div>
    <div class="footer">
      <div class="footerL footerCon">
        <div class="aboutTCon_tit">
          <span class="chinaTit">{{contactUs.attrValue?contactUs.attrValue.name:""}}</span>
          <span class="engTit">{{contactUs.attrValue?contactUs.attrValue.abbreviation:""}}</span>
        </div>
        <div class="footerL_info" v-html="contactUs.attrValue?contactUs.attrValue.content:''"></div>
      </div>
      <div class="footerR footerCon">
        <div class="aboutTCon_tit">
          <span class="chinaTit">{{relevantResources.attrValue?relevantResources.attrValue.name:""}}</span>
          <span
            class="engTit"
          >{{relevantResources.attrValue?relevantResources.attrValue.abbreviation:""}}</span>
        </div>
        <div
          class="footerL_info"
          v-html="relevantResources.attrValue?relevantResources.attrValue.content:''"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "about",
  data() {
    return {
      loading: true,
      aboutT: {},
      history: {},
      how: {},
      contactUs: {},
      relevantResources: {},
      workingTeam: {
        chinaTit: "行星系统命名工作组",
        engTit: "WGPSN"
      },
      wgpsn: {
        // list: [
        // {
        //   child: [
        //     {
        //       name: "姓名",
        //       country: "代表国家"
        //     },
        //     {
        //       name: "R. Schulz",
        //       country: "德国"
        //     },
        //     {
        //       name: "K. Aksnes",
        //       country: "挪威"
        //     },
        //     {
        //       name: "G. Consolmagno",
        //       country: "梵蒂冈城"
        //     },
        //     {
        //       name: "R.洛佩斯",
        //       country: "联合王国"
        //     }
        //   ]
        // },
        // {
        //   child: [
        //     {
        //       name: "姓名",
        //       country: "代表国家"
        //     },
        //     {
        //       name: "R. Schulz",
        //       country: "德国"
        //     },
        //     {
        //       name: "K. Aksnes",
        //       country: "挪威"
        //     },
        //     {
        //       name: "G. Consolmagno",
        //       country: "梵蒂冈城"
        //     },
        //     {
        //       name: "R.洛佩斯",
        //       country: "联合王国"
        //     }
        //   ]
        // },
        // {
        //   child: [
        //     {
        //       name: "姓名",
        //       country: "代表国家"
        //     },
        //     {
        //       name: "R. Schulz",
        //       country: "德国"
        //     },
        //     {
        //       name: "K. Aksnes",
        //       country: "挪威"
        //     },
        //     {
        //       name: "G. Consolmagno",
        //       country: "梵蒂冈城"
        //     },
        //     {
        //       name: "R.洛佩斯",
        //       country: "联合王国"
        //     }
        //   ]
        // }
        // ]
      },
      faq: {
        chinaTit: "常见问答",
        engTit: "FAQ",
        icon: "el-icon-arrow-down",
        openIcon: "el-icon-arrow-up"
      },
      faq_list: []
    };
  },
  created() {
    var that = this;
    that.getBriefData();
    that.getHistoryData();
    that.getApproveData();
    that.getCallUsData();
    that.getRelevantResourcesData();
    that.getWorkingTeamData(); //行星命名工作组
    that.getRelatedResourcesData(); //常见问答
  },
  methods: {
    getBriefData() {
      var that = this;
      that
        .axios({
          type: "get",
          url: "/front/resource/detail",
          params: {
            id: that.config.channelId.about.brief.id
          }
        })
        .then(function(res) {
          that.aboutT = res.data.result;
          that.briefLoading = false;
        });
    },
    getHistoryData() {
      var that = this;
      that
        .axios({
          type: "get",
          url: "/front/resource/detail",
          params: {
            id: that.config.channelId.about.history.id
          }
        })
        .then(function(res) {
          that.history = res.data.result;
          that.getApproveData();
        });
    },
    getApproveData() {
      var that = this;
      that
        .axios({
          type: "get",
          url: "/front/resource/detail",
          params: {
            id: that.config.channelId.about.approve.id
          }
        })
        .then(function(res) {
          that.how = res.data.result;
          that.loading = false;
        });
    },
    getCallUsData() {
      var that = this;
      that
        .axios({
          type: "get",
          url: "/front/resource/detail",
          params: {
            id: that.config.channelId.about.callUs.id
          }
        })
        .then(function(res) {
          that.contactUs = res.data.result;
          that.loading = false;
        });
    },
    getRelevantResourcesData() {
      var that = this;
      that
        .axios({
          type: "get",
          url: "/front/resource/detail",
          params: {
            id: that.config.channelId.about.relatedResources.id
          }
        })
        .then(function(res) {
          that.relevantResources = res.data.result;
          that.loading = false;
        });
    },
    getWorkingTeamData() {
      var that = this;
      that
        .axios({
          type: "get",
          url: "/front/resource/queryPageList",
          params: {
            categoryId: that.config.channelId.about.workingTeam.id
          }
        })
        .then(function(res) {
          //  res.data.result.attrValue = JSON.parse(res.data.result.attrValue);
          // for (let key in res.data.result.attrValue) {
          //   res.data.result[key] = res.data.result.attrValue[key];
          // }
          that.wgpsn = res.data.result;
          that.initSwiper();
        });
    },
    getRelatedResourcesData() {
      var that = this;
      that
        .axios({
          type: "get",
          url: "/front/resource/queryPageList",
          params: {
            categoryId: that.config.channelId.about.qa.id,
            page:1,
            limit: 3
          }
        })
        .then(function(res) {
          that.faq_list = res.data.result;
        });
    },
    qaMore() {
      var that = this;
      that.$router.push({
        path: "/doc",
        query: {
          id: that.config.channelId.about.qa.id
        }
      });
    },
    initSwiper() {
      new Swiper(".swiper-container", {
        slidesPerView: 3,
        effect: "coverflow",
        // slidesPerGroup: 1,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        centeredSlides: true,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        coverflowEffect: {
          rotate: 0,
          stretch: -38,
          depth: 80,
          modifier: 2,
          slideShadows: false
        }
      });
    }
  }
};
</script>

<style scoped>
.about {
  width: 1320px;
  margin: 0 auto;
  padding: 30px 0;
  box-sizing: border-box;
}
.aboutBox {
  background-color: #ffffff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  padding: 30px;
  box-sizing: border-box;
  width: 100%;
}
.flex {
  display: flex;
}
.flex_d {
  flex-direction: column;
}
.jus {
  justify-content: space-between;
}
.alignItem {
  align-items: center;
}
.centerT {
  text-align: center;
}
.aboutTImg,
.aboutTImg img {
  width: 436px;
  height: 365px;
  background-color: #696868;
}
.aboutTCon {
  /* width: 704px; */
  flex: 1;
  margin-left: 16px;
}
.chinaTit {
  font-size: 30px;
  color: #242424;
  display: block;
  margin-bottom: 10px;
}
.engTit {
  color: #b5b5b5;
  font-size: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #0072ff;
}
.aboutTCon_brief p {
  text-indent: 2em;
  font-size: 14px;
  color: #666;
  line-height: 27px;
}
.aboutTCon_brief p span {
  color: #0072ff;
}
.aboutTCon_brief {
  padding-top: 10px;
  margin-top: 16px;
}
.navBox + .navBox {
  margin-top: 28px;
}
.history .aboutTCon_brief span {
  font-size: 16px;
  color: #333;
  line-height: 30px;
}
/* how */
.how {
  background-color: #eee;
  padding: 30px;
  box-sizing: border-box;
  width: 100%;
}
.how .aboutTCon_brief p {
  color: #666;
}
/* wgpsn */
.wgpsn {
  padding: 30px;
  box-sizing: border-box;
  background-color: #ffffff;
  opacity: 0.99;
}
.con_item {
  flex: 1;
}
.faq {
  padding: 30px;
  box-sizing: border-box;
  background-color: #eaedf4;
}
.faq_list_item {
  height: auto;
  padding: 25px 0;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 30px;
}
.faq_list_item + .faq_list_item {
  border-top: 1px solid #b2b2b2;
}
.ask {
  font-weight: 600;
}
/* .answer {
} */
.answer_con {
  display: flex;
}

.more {
  color: #0072ff;
  font-size: 15px;
  width: 120px;
  height: 44px;
  background-color: #d9eaff;
  border-radius: 5px;
  border: solid 1px #8cbfff;
  box-sizing: border-box;
  text-align: center;
  line-height: 44px;
  margin: 0 auto;
  cursor: pointer;
}
/* 关于我们底部 */
.footer {
  background-color: #fff;
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
}
.footerCon {
  flex: 1;
}
.footerL_info {
  padding-top: 20px;
}

/* 轮播 */
.wgpsnB {
  margin-top: 60px;
  height: 600px;
}
.wgT {
  font-size: 18px;
  font-weight: 600;
  color: #292b2c;
  line-height: 30px;
}
.wg_tit {
  color: #292b2c;
  font-size: 16px;
  font-weight: 600;
  line-height: 30px;
}
.wg_con {
  font-size: 14px;
  line-height: 30px;
}
.wgpsn_item_T {
  margin-right: 20px;
}
.wgpsn_item_B {
  flex: 1;
}
.wg_con_item_c {
  width: 50%;
}
.swiper-wrapper {
  height: 100%;
}
.swiper-slide {
  border: solid 1px #c2c2c2;
  padding: 20px 15px;
  box-sizing: border-box;
  height: 100%;
}
.swiper-slide-active {
  background-color: #fff;
  box-shadow: 0px 4px 35px 8px rgba(0, 0, 0, 0.15);
  border-color: #fff;
}
</style>

<style>
.el-carousel__item--card.is-in-stage {
  width: 33.3%;
}

.swiper-container-horizontal>.swiper-pagination-bullets{
  bottom: 0;
}

.footerL_info p{
  margin-block-start: 1em;
  margin-block-end: 1em;
}

.answer_con p{
  width: 860px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
</style>
